import '../css/my-account.scss';
import $ from '@modules/jquery-import';
import OrderHistoryController from '@modules/orders/OrderHistoryController';
import OrderItemFullDetailController from '@modules/orders/orderItemFullDetailController';
import {jqueryValidate, Corpus} from '@modules/lazy-imports';

/**
 * Initialize DOM for Page
 */
var Page = (function () {

    /** helpers **/

    // expose this object to a namespace
    return {

        nodes: {},

        init: async function () {
            await Promise.all( [jqueryValidate(), Corpus()] );
            $( this.onDOMContentLoaded );

            this.nodes.$siteContent = $( '#page-content' );

            if ( document.getElementById( 'odr-history-container' ) ) {
                new OrderHistoryController( '#odr-history-container' );
            }

            // exclude pending orders
            const trackedOrders = $( '[data-order-status]' ).filter( function () {
                return !/pending/.test( this.getAttribute( 'data-order-status' ) );
            } );

            if ( trackedOrders.length ) {
                this.getOrderDetails( trackedOrders );
            }
        },

        onDOMContentLoaded: function () {
            $( '#passwordResetForm' ).validate();
        },

        getOrderDetails: function ( trackedOrders ) {
            // initialize Order Detail module
            this.nodes.$siteContent.corpus( 'tabs', {
                controls: '.tabNavigation',
                panel: '.tabPanel',
                active_class: 'current'
            } );

            trackedOrders.each( function () {
                new OrderItemFullDetailController( this );
            } );
        }
    };
}());

$( () => Page.init() );
